"use client";
import { motion } from "framer-motion";
import { Sparkles, Shield, Users, Award } from "lucide-react";
import { cn } from "@/lib/utils";
import { gsdentalStats } from "@/lib/const/GsDental";
import { NumberTicker } from "@/components/magicui/number-ticker";

const bornYear = 2014;
const experience = new Date().getFullYear() - bornYear;

export function AboutHeader({ containerVariants, itemVariants, isInView }) {
  // Crear copia local de stats con el valor calculado, sin mutar el módulo original
  const stats = gsdentalStats.map((stat, i) =>
    i === 0 ? { ...stat, number: experience } : stat,
  );
  return (
    <>
      <motion.div
        className="text-center mb-20"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div
          className="inline-flex items-center space-x-2 bg-primary-100 text-primary-800 px-4 py-2 rounded-full text-sm font-medium mb-6"
          variants={itemVariants}
        >
          <Sparkles className="w-4 h-4" />
          <span>Excelencia en Salud Dental</span>
        </motion.div>
        <motion.h2
          className="text-5xl md:text-6xl font-bold text-title mb-4 leading-tight"
          variants={itemVariants}
        >
          Sobre <span className="text-primary">Nosotros</span>
        </motion.h2>
        <motion.p
          className="text-3xl md:text-4xl font-bold text-primary-foreground mb-6 leading-tight"
          variants={itemVariants}
        >
          GS<span className="text-primary-700">DENTAL</span>
        </motion.p>
        <motion.p
          className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed"
          variants={itemVariants}
        >
          Atención dental integral para adultos y niños, con un enfoque 100%
          personalizado. Creamos un plan de tratamiento hecho a tu medida,
          enfocado en tus necesidades específicas y brindándote soluciones
          reales. Combinamos experiencia profesional, tecnología moderna y un
          trato cercano para ayudarte a
          <span className="text-primary font-semibold">
            {" "}
            lograr la mejor versión de tu sonrisa.
          </span>
        </motion.p>
        {/* <motion.p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" variants={itemVariants}>
					Brindamos atención dental integral con los más altos estándares de calidad, combinando experiencia profesional con tecnología moderna para ofrecerte
					<span className="text-[#BE203A] font-semibold"> la mejor sonrisa de tu vida</span>.
				</motion.p> */}
      </motion.div>

      {/* Stats Section */}
      <motion.div
        className="grid grid-cols-2 md:grid-cols-3 gap-8 "
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className={cn("text-center group")}
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="relative inline-block mb-4">
              <div className="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center group-hover:shadow-lg transition-shadow duration-300">
                <stat.icon className="size-10 text-primary" />
              </div>
            </div>
            <div className="text-3xl font-bold mb-2 text-primary-foreground">
              <NumberTicker
                value={stat.number}
                startValue={stat.start}
                className={"text-primary-foreground"}
              />
              +
            </div>
            <div className="text-slate-600 font-medium">{stat.label}</div>
          </motion.div>
        ))}
      </motion.div>
    </>
  );
}
